module.exports = __webpack_public_path__ + "media/assets/5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/5.svg
// module id = 16
// module chunks = 0